import React from "react";
import { Label } from "reactstrap";
import { Autocomplete, TextField } from "@mui/material";

const RegisterSchoolSelector = ({
  sportLevel,
  state,
  setState,
  college,
  setCollege,
  newSchool,
  setNewSchool,
  stateOptions,
  defaultCollegeProps,
  defaultNewSchoolProps,
  getSelectedOption,
  setLawData,
  toggleLawModal,
}) => {
  return (
    <>
      <Label className="mt-5 auth-label">Address Where School Located</Label>
      <br />

      <Label className="auth-label mt-3">State</Label>
      <Autocomplete
        options={stateOptions}
        getOptionLabel={(option) => option?.name || ""}
        isOptionEqualToValue={(option, value) =>
          (option?.name || "") === (value?.name || "")
        }
        id="state-autocomplete"
        autoComplete
        includeInputInList
        value={getSelectedOption(stateOptions, state)}
        onChange={(e, val) => {
          const selectedName = val?.name || "";
          setState(selectedName);
          setLawData(val || {});

          // Open state law modal if the selected state has law data
          if (val && val.limit && toggleLawModal) {
            toggleLawModal();
          }

          if (selectedName === "OTHER") {
            setCollege("OTHER");
            setNewSchool("OTHER");
          } else {
            setCollege("");
            setNewSchool("");
          }
        }}
        renderInput={(params) => (
          <>
            <TextField
              {...params}
              placeholder="State"
              variant="standard"
              inputProps={{ ...params.inputProps, value: state || "" }}
            />
          </>
        )}
      />

      <br />

      <Label className="auth-label mt-3">
        {sportLevel === "College athlete" ? "City" : "County"}
      </Label>
      <Autocomplete
        options={[...(defaultCollegeProps?.options || [])]}
        getOptionLabel={(option) =>
          typeof option === "string" ? option : option?.name || ""
        }
        isOptionEqualToValue={(option, value) =>
          (option?.name || option) === (value?.name || value)
        }
        id="auto-complete-college"
        autoComplete
        includeInputInList
        disabled={!state || state === "OTHER"}
        value={college || null}
        onChange={(e, val) => {
          setCollege(val || "");
          if (val === "OTHER") {
            setNewSchool("OTHER");
          } else {
            setNewSchool("");
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={sportLevel === "College athlete" ? "City" : "County"}
            variant="standard"
            inputProps={{ ...params.inputProps, readOnly: true }}
          />
        )}
      />

      <Label className="auth-label mt-3">School</Label>
      <Autocomplete
        options={[...(defaultNewSchoolProps?.options || [])]}
        getOptionLabel={(option) =>
          typeof option === "string" ? option : option?.name || ""
        }
        isOptionEqualToValue={(option, value) =>
          (option?.name || option) === (value?.name || value)
        }
        id="auto-complete-school"
        autoComplete
        includeInputInList
        disabled={!state || !college || state === "OTHER"}
        value={newSchool || null}
        onChange={(e, val) => setNewSchool(val || "")}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Select your School from Dropdown menu"
            variant="standard"
            inputProps={{ ...params.inputProps, readOnly: true }}
          />
        )}
      />

      <Label className="custom-label">
        (School name not listed on any NIL commercial objects. Used for
        compliance checking.)
      </Label>
    </>
  );
};

export default RegisterSchoolSelector;
